export default __webpack_public_path__ + "static/media/icon_cat_DiamondAnniversaryBands.683261b1.png";